export default {
    /* GET_COMPLAINTS
    ---------------------------------------------------------------
    */
    GET_COMPLAINTS_REQUEST: state => {
        state.complaintsLoading = true
    },
    GET_COMPLAINTS_SUCCESS: (state, data) => {
        state.complaints = data.results
        state.complaintsLoading = false
    },
    GET_COMPLAINTS_FAILURE: state => {
        state.complaintsLoading = false
    },
    /* GET_COMPLAINT
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_SUCCESS: (state, data) => {
        state.complaintAttachments = data.complaintAttachment
    },
    /* GET_COMPLAINT_TYPES
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_TYPES_SUCCESS: (state, data) => {
        state.complaintTypes = data
    },
    /* GET_COMPLAINT_STATUSES
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_STATUSES_SUCCESS: (state, data) => {
        state.complaintStatuses = data
    },
    /* GET_COMPLAINT_MATERIALS
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_MATERIALS_SUCCESS: (state, data) => {
        state.complaintMaterials = data
    },
    /* GET_COMPLAINT_REMOVE_REASONS
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_REMOVE_REASONS_SUCCESS: (state, data) => {
        state.complaintRemoveReasons = data
    },
    /* GET_COMPLAINT_UNITS
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_UNITS_SUCCESS: (state, data) => {
        state.complaintUnits = data
    },
    /* GET_USER_DEPARTMENTS
    ---------------------------------------------------------------
    */
    GET_PRODUCTION_DEPARTMENTS_SUCCESS: (state, data) => {
        state.productionDepartments = data
    },
    GET_PRODUCTION_SITE_GROUPS_SUCCESS: (state, data) => {
        state.productionSiteGroups = data
    },
    GET_PRODUCTION_PROCESSES_SUCCESS: (state, data) => {
        state.productionProcesses = data
    },
    GET_MACHINES_SUCCESS: (state, data) => {
        state.machines = data
    },
    GET_REPORT_ITEMS_SUCCESS: (state, data) => {
        state.reportItems = data
    },
    /* GET_USERS
    ---------------------------------------------------------------
    */
    GET_USERS_SUCCESS: (state, data) => {
        state.users = data
    },
    SET_COMPLAINTS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    UPDATE_PRODUCTION_NUMBERS_LIST: (state, orders, selectedOrdersProductionNumbers) => {
        state.productionNumbersList = []
        orders.forEach(order => state.productionNumbersList.push(`${order.order_full_number_cfprint} - ${order.produkt_nazwa}`))
        state.orderNumbers = selectedOrdersProductionNumbers
    },
    SET_ORDER_NUMBER: (state, productionNumbers) => {
        state.productionNumbersList = []
        if (typeof productionNumbers !== 'string' || productionNumbers.length == 0) {
            state.orderNumbers = []
        } else {
            let productionNumbersList = productionNumbers.split(',')

            state.orderNumbers = productionNumbers.split(',')
            productionNumbersList.forEach(productionNumber => state.productionNumbersList.push(productionNumber))
        }
    },
    UPDATE_PRODUCTION_NUMBERS: (state, selectedOrdersProductionNumbers) => {
        state.productionNumbersList = selectedOrdersProductionNumbers
    },
    /* GET_COMPLAINT_ERROR_SUCCESS
    ---------------------------------------------------------------
    */
    GET_COMPLAINT_ERROR_SUCCESS: (state, data) => {
        state.errors = data
    },
    SET_USERS_LIST: (state, data) => {
        state.users = data
    },
    SET_CANCEL_TOKEN: (state, { token, fileName }) => {
        state.uploadCancelTokens.push({token, fileName})
    },
    REMOVE_CANCEL_TOKEN: (state, tokenIndex) => {
        state.uploadCancelTokens.splice(tokenIndex, 1)
    },
    ABORT_FILE_UPLOAD: (state, fileName) => {
        const index = state.uploadCancelTokens.findIndex(item => item.fileName === fileName)

        state.uploadCancelTokens[index].token.cancel('canceled')
    },
    CLEAR_COMPLAINTS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    SET_COMPLAINTS_LOADING: (state, bool) => {
        state.complaintsLoading = bool
    }
}